export default __webpack_public_path__ + "static/l8-portfolio-img-2-4691d7656b44a5e0cec037299074e9e3.jpg";